<ng-template #body>
  <div class="filter-row">
      <ng-container *ngTemplateOutlet="filterForm.template" ></ng-container>
    @if (insideCard()) {
      <button
      nbButton
      ghost
      status="primary"
      (click)="applyFormValueToFilter()">
      <nb-icon
        pack="eva"
        icon="search-outline"></nb-icon>
    </button>
    }

    @if (!insideCard()) {
    <div class="no-card-filter-actions">
      <button
        nbButton
        ghost
        status="primary"
        (click)="applyFormValueToFilter()">
        <nb-icon
          pack="eva"
          icon="search-outline"></nb-icon>
      </button>
      <div class="additional-actions">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
    </div>
    }
  </div>

  @if (data$ | async; as data) {
    <table [cypressId]="localStorageIdentifier()">
      <thead>
        <tr>
          @for (c of columns(); track c) {
            <th
              [class.sortable]="c.sortable"
              (click)="toggleSort(c)">
              <div class="th-flex">
                <span>
                  {{ c.display }}
                </span>
                @switch (sortOrderOf(c)) {
                  @case ('ASC') {
                    <nb-icon
                      pack="eva"
                      icon="arrow-ios-downward"></nb-icon>
                  }
                  @case ('DESC') {
                    <nb-icon
                      pack="eva"
                      icon="arrow-ios-upward"></nb-icon>
                  }
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of data.items; track item; let i = $index) {
          <tr
            (click)="lineClick.emit(item)"
            [attr.data-cy]="'table-row-' + i"
            [class.deprecated]="deprecatedRows() && isDeprecated(item)">
            @for (column of columns(); track column) {
              <td>
                <ng-container *ngTemplateOutlet="column.template; context: { $implicit: item }"></ng-container>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    @if (data.items.length === 0) {
      <div
        class="no-entries"
        cypressId="empty-list"
        >Keine Einträge gefunden</div
      >
    }
  }
</ng-template>

<ng-template #footer>
  <div class="footer">
    <div class="page-size">
      <nb-select
        [ngModel]="pageSize$ | async"
        (ngModelChange)="changePageSize($event)">
        @for (size of pageSizes; track size) {
          <nb-option
            [value]="size"
            >{{ size }}</nb-option
          >
        }
      </nb-select>
    </div>
    @if (data$ | async; as data) {
      <wr-pagination
        [page$]="page$"
        [maxPage]="ceil(data.count / pageSize$.value) - 1"></wr-pagination>
    }
    <div class="placeholder"></div>
  </div>
</ng-template>

<!-- Render content with card around it -->
@if (insideCard()) {
  <nb-card [nbSpinner]="(loading$|async) === true || (externalLoading$()|async) === true">
    @if (headerText()) {
      <nb-card-header>
        <div class="header">
          <span>{{ headerText() }}</span>
          <ng-container *ngTemplateOutlet="actions"></ng-container>
        </div>
      </nb-card-header>
    }

    <nb-card-body>
      @if (infoBanner(); as banner) {
        <wr-banner class="info-banner"
                   [icon]="{ icon: 'info-outline', pack: 'eva' }"
                   status="info"
                   [message]="banner">
        </wr-banner>
      }
      <ng-container *ngTemplateOutlet="body"></ng-container>
    </nb-card-body>

    <nb-card-footer>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </nb-card-footer>
  </nb-card>
}

<!-- Render content without card around it -->
@if (!insideCard()) {
  <div class="cardless" [nbSpinner]="(loading$|async) === true || (externalLoading$()|async) === true">
    <ng-container *ngTemplateOutlet="body"></ng-container>
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>
}

<ng-template #actions>
  <div class="flex-div">
    @for (action of customActions(); track action) {
      <button
        class="action"
        nbButton
        [status]="action.status"
        [nbTooltip]="action.tooltip!"
        [nbTooltipStatus]="action.status"
        [nbTooltipDisabled]="!action.tooltip"
        (click)="action.action()">
        @if (action.icon; as icon) {
          <nb-icon [config]="icon"></nb-icon>
        }
        @if (action.title; as title) {
          <span>{{ title }}</span>
        }
      </button>
    }
    <button nbButton status="primary" (click)="onExportClick($event)"
            [disabled]="(exportLoading$ | async) ?? false"
            [nbSpinner]="(exportLoading$ | async) ?? false"
            nbSpinnerStatus="primary"
            nbSpinnerSize="small">
      <nb-icon pack="eva" icon="download-outline"></nb-icon>
    </button>
    @if (isAdmin() && showNewButton()) {
      <button class="create-button" nbButton status="primary" (click)="newClick.emit()" cypressId="create-button">
        <nb-icon pack="eva" icon="plus-outline"></nb-icon>
      </button>
    }
  </div>
</ng-template>
